let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("RA3Jm")).then(() => parcelRequire('i12BE'));